
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import Search from './pages/Search';
import About from './pages/About';
import Contact from './pages/Contact';
import HowItWorks from './pages/HowItWorks';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import PropertyDetails from './pages/PropertyDetails';
import MyListings from './pages/MyListings';
import Profile from './pages/Profile';
import TourRedirect from './pages/TourRedirect';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AuthRoute from './components/AuthRoute';
import './App.css';

function App() {

  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/search" element={<Search />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/about" element={<About />} />
            {/* <Route path="/signin" element={<SignIn />} /> */}
            {/* <Route path="/signup" element={<SignUp />} /> */}
            <Route path="/properties/:id" element={<PropertyDetails />} />
            <Route
              path="/my-listings"
              element={
                <AuthRoute>
                  <MyListings />
                </AuthRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <AuthRoute>
                  <Profile />
                </AuthRoute>
              }
            />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/tours/:id" element={<TourRedirect />} />
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
